import { apiGet, apiPost, apiPut } from '../utils/api'
import Hotjar from '@hotjar/browser'

export const getCategories = () => {
  return apiGet(`master/categories/list/`)
}

export const getCategoriesByFilter = (skip, limit, term, filter, lastVersion) => {
  return apiGet(
    `master/categories/list/?skip=${skip}&limit=${limit}&term=${term}&filter=${filter}`,
    [],
    {},
    {},
    lastVersion,
  )
}

export const getCombinedCategoriesByFilter = (skip, limit, term, filter, type, lastVersion) => {
  return apiGet(
    `master/categories/list/all?skip=${skip}&limit=${limit}&term=${term}&filter=${filter}&type=${type}`,
    [],
    {},
    {},
    lastVersion,
  )
}

export const getChildCategories = (shopId) => {
  return apiGet(`mgmt/categories/list/children?shopId=${shopId}`)
}

export const updateSingleMasterCategory = (data) => {
  Hotjar.event('update_single_master_category')
  return apiPost(`master/categories/crud/update/${data.id}`, data)
}

export const updateMasterCategory = (data) => {
  Hotjar.event('update_master_category')
  return apiPost(`master/categories/bulk/update`, data)
}

export const updateOrphanCategoriesAPI = (data) => {
  Hotjar.event('update_orphan_categories')
  return apiPost(`mgmt/categories/bulk/updateOrphans`, data)
}

export const validateStoreCategoriesAPI = (shopId) => {
  return apiGet(`mgmt/categories/list/validateStoreCategories/${shopId}`)
}

export const bulkUpdateChildCategoriesAPI = (data) => {
  Hotjar.event('bulkupdate_child_categories')
  return apiPost(`mgmt/categories/bulk/updateByMaster`, data)
}

export const setArchiveMasterCategory = (data) => {
  Hotjar.event('set_archive_master_category')
  return apiPost(`master/categories/crud/archive`, data)
}

export const setChildCategory = (data) => {
  Hotjar.event('set_child_category')
  return apiPost(`master/categories/adopt/createChild`, data)
}

export const updateShopSettings = (data, groupName) => {
  Hotjar.event('update_shopSettings')
  return apiPost(`mgmt/shopSettings/update/${groupName}`, data)
}

export const addMasterCategoryAPI = (category) => {
  Hotjar.event('add_master_category')
  return apiPost(`master/categories/crud/`, category)
}

export const getVendors = () => {
  return apiGet('mgmt/vendors')
}

export const getBrands = () => {
  return apiGet('mgmt/brands/list/brands')
}

export const getTemplatePrice = () => {
  //return apiGet("mgmt/products/pricingTemplates");
  return apiGet('mgmt/products/pricingTemplate/all')
}

export const listProductTags = () => {
  return apiGet('mgmt/shops/productTags')
}

export const getMemberGroups = () => {
  return apiGet('mgmt/settings/memberGroups/all')
}

export const setMasterProduct = (data) => {
  Hotjar.event('set_master_product')
  return apiPost(`master/products/crud/create`, data)
}

export const getMasterProduct = (id) => {
  return apiGet(`master/products/get/${id}`)
}

export const getMasterProductWithChilds = (id) => {
  return apiGet(`master/products/get/master/${id}`)
}

export const getMasterCategoryAPI = (id) => {
  return apiGet(`master/categories/get/${id}`)
}

export const getCombineProducts = (
  start,
  limit,
  lastVersion,
  term = '',
  filter = [],
  sortBy = 'name',
  sortByDirection = 'asc',
  type = 'master',
) => {
  const qTerm = encodeURIComponent(term) //url encode the term
  return apiGet(
    `search/master/products?start=${start}&limit=${limit}&term=${qTerm}&filter=${filter}&sortBy=${sortBy}&sortByDirection=${sortByDirection}&type=${type}`,
    [],
    {},
    {},
    lastVersion,
  )
}

export const getCombineMasterProductsV2 = (
  start,
  limit,
  lastVersion,
  term = '',
  filter = '',
  sortBy = 'name',
  sortByDirection = 'asc',
  type = 'master',
  masterCategoryIds = [],
  brandIds = [],
  vendorIds = [],
) => {
  let filterString = ''
  if (filter instanceof Array) {
    filterString = filter.join(',')
  } else {
    filterString = filter
  }
  if (masterCategoryIds.length > 0) {
    filterString = filterString + ';masterCategoryIds:'
    filterString = filterString + masterCategoryIds.join(',')
  }

  if (brandIds.length > 0) { 
    filterString = filterString + ';brandIds:'
    filterString = filterString + brandIds.join(',')
  }

  const qTerm = encodeURIComponent(term) //url encode the term
  return apiGet(
    `search/master/products?start=${start}&limit=${limit}&term=${qTerm}&filter=${filterString}&sortBy=${sortBy}&sortByDirection=${sortByDirection}&type=${type}`,
    [],
    {},
    {},
    lastVersion,
  )
}

export const searchAvailableMasterProductsAPI = (
  start,
  limit,
  term = '',
  sortBy = 'name',
  sortByDirection = 'asc',
) => {
  const qTerm = encodeURIComponent(term) //url encode the term
  return apiGet(
    `master/products/list/available?start=${start}&limit=${limit}&term=${qTerm}&sortBy=${sortBy}&sortByDirection=${sortByDirection}`,
  )
}

export const getChildProduct = (id) => {
  return apiGet(`mgmt/products/${id}`)
}

export const setArchiveMasterProduct = (data) => {
  Hotjar.event('set_archive_master_product')
  return apiPost(`master/products/crud/archive`, data)
}

export const updateMasterProduct = (data) => {
  Hotjar.event('update_master_product')
  return apiPost(`master/products/bulk/update`, data)
}

export const setChildProduct = (data) => {
  Hotjar.event('set_child_product')
  return apiPost(`master/products/adopt/createChild`, data)
}

export const updateChildProduct = (data) => {
  Hotjar.event('update_child_product')
  return apiPost(`mgmt/products/${data.id}`, data)
}

export const updateChildProducts = (masterProduct, shopIds) => {
  Hotjar.event('update_child_products')
  return apiPost(`mgmt/products/crud/update/children`, {
    masterProduct: masterProduct,
    shopIds: shopIds,
  })
}

export const removeChildProducts = (masterProduct, shopIds) => {
  Hotjar.event('remove_child_products')
  return apiPost(`mgmt/products/bulk/removeChildren`, {
    masterProduct: masterProduct,
    shopIds: shopIds,
  })
}

export const removeChildCategories = (masterCategory, shopIds) => {
  Hotjar.event('remove_child_categories')
  return apiPost(`mgmt/categories/bulk/removeChildren`, {
    masterCategory: masterCategory,
    shopIds: shopIds,
  })
}

export const updateBulkUpdateChild = (data) => {
  Hotjar.event('update_bulkupdate_child')
  return apiPost(`mgmt/products/bulk/updateChildren`, data)
}

export const updateProductTagsAPI = (shopIds, productTags) => {
  Hotjar.event('update_product_tags')
  return apiPost(`mgmt/shops/update/productTags`, { shopIds, productTags })
}

export const updateSingleMasterProduct = (data) => {
  Hotjar.event('update_single_master_product')
  return apiPost(`master/products/crud/update/${data.id}`, data)
}

export const unlinkProductFromParent = (id) => {
  Hotjar.event('unlik_profuct_from_parent')
  return apiPut(`master/products/adopt/unlinkChild/${id}`)
}

export const unlinkCategoryFromParent = (id) => {
  Hotjar.event('unlik_category_from_parent')
  return apiPut(`master/categories/adopt/unlinkChild/${id}`)
}

export const getSMasterProducts = (start, limit, term, filter, lastVersion, type = 'master') => {
  return apiGet(
    `search/master/products?start=${start}&limit=${limit}&term=${term}&filter=${filter}&type=${type}`,
    [],
    {},
    {},
    lastVersion,
  )
}

export const updateComplexPricing = (data) => {
  Hotjar.event('update_complex_pricing')
  return apiPost(`mgmt/products/crud/update/pricing`, data)
}

export const addLocationToMasterProduct = (data) => {
  return apiPost('master/products/adopt/addLocation', data)
}

export const getInventories = (shopId) => {
  return apiGet('mgmt/inventory?shopId=' + (shopId ? shopId : ''))
}

export const getBatches = (id, shopId) => {
  return apiGet(`mgmt/batch/list?productId=${id ? id.masterId : ''}&shopId=${shopId ? shopId : ''}`)
}

export const getProductQuantityInfo = (id) => {
  return apiGet(`mgmt/products/${id.masterId}/quantityInfo`)
}

export const adoptOrphanCategoriesAPI = (data) => {
  Hotjar.event('adopt_orphan_categories')
  return apiPost('master/categories/adopt/', data)
}

export const adoptOrphanProductsAPI = (data) => {
  Hotjar.event('adopt_orphan_products')
  return apiPost('master/products/adopt', data)
}

export const getBlazeCategoriesAPI = () => {
  return apiGet(`blazecategories/list/`)
}

export const getMetrcCategoryListAPI = () => {
  return apiGet(`mgmt/compliance/categories/list/`)
}

export const updateProductCategory = (data) => {
  Hotjar.event('update_product_category')
  return apiPost(`mgmt/inventory/categories/${data.id}`, data)
}

export const updateChildCategories = (masterCategory, shopIds) => {
  Hotjar.event('update_child_categories')
  return apiPost(`mgmt/categories/crud/update/children`, {
    masterCategory: masterCategory,
    shopIds: shopIds,
  })
}



// WEBPACK FOOTER //
// ./src/api/masterCatalog.js